import { useClassified } from "@/contexts/classified";
import { getTrackingQueryParams } from "./utils/getTrackingQueryParams";
import { useTrackingPromotion } from "./useTrackingPromotion";
export const useTrackingDatas = () => {
    var _a;
    const { list_name } = getTrackingQueryParams();
    const trackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking;
    const promotion = useTrackingPromotion();
    return {
        ...trackingData,
        av_items: trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items.filter((item) => item.list_name !== "classified_detail_similars_bottom").map((item) => ({
            ...item,
            list_name: item.index === 0 && list_name ? list_name : item.list_name,
            ...(promotion && { promotion }),
        })),
    };
};
export const useTrackingAvDistributionType = () => { var _a, _b; return (_b = (_a = useTrackingDatas()) === null || _a === void 0 ? void 0 : _a.av_distribution_type_global) !== null && _b !== void 0 ? _b : ""; };
const useItemsDatas = (conversionType) => {
    const { av_items } = useTrackingDatas();
    const [currentItem, ...rest] = av_items !== null && av_items !== void 0 ? av_items : [];
    return conversionType
        ? [{ ...currentItem, conversion_type: conversionType }, ...rest]
        : av_items;
};
export const useTrackingEventsDatas = ({ conversionType, displayMedium, }) => ({
    ...useTrackingEventsDatasNoItems(displayMedium),
    av_items: useItemsDatas(conversionType),
});
export const useTrackingEventsDatasNoItems = (displayMedium = false) => {
    var _a, _b, _c, _d;
    const { av_medium } = getTrackingQueryParams();
    const shouldDisplayMedium = displayMedium && !!av_medium;
    return {
        av_distribution_type_global: useTrackingAvDistributionType(),
        av_estate_type_global: (_b = (_a = useTrackingDatas()) === null || _a === void 0 ? void 0 : _a.av_estate_type_global) !== null && _b !== void 0 ? _b : "",
        av_category: (_d = (_c = useTrackingDatas()) === null || _c === void 0 ? void 0 : _c.av_category) !== null && _d !== void 0 ? _d : "",
        ...(shouldDisplayMedium && { av_medium }),
    };
};
